/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
import React, { useEffect, useState, useCallback } from 'react'
import {
  Button,
  Grid,
  InputBase,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  makeStyles,
} from '@material-ui/core'
import NumberFormat from 'react-number-format'

import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../../../components/hooks/BaseTableComponents'
import { getSorting, stableSort } from '../../../../../util/TableUtils'
import colors from '../../../../../assets/colors'
import { exportFormatedMoney } from '../../../../../util/utils'
import { CustomCheckbox } from '../../../../../components/ui/custom-checkbox'
import { CustomSwitch } from '../../../../../components/ui/custom-switch'
import TableHeadCells from '../../../../components/TableHeadCells'
import BasePopUp from '../../../../../components/hooks/BasePopUp'
import { useSelector, useDispatch } from 'react-redux'
import filterStylesComponents from '../../../../../assets/filterComponentsStyles'
import {
  removeLaundryServiceType,
  updateLaundryServiceType,
  bulkSaveLaundryServiceTypes,
  bulkDestroyLaundryServiceTypes,
} from '../../PartnersActions'

const OS_TYPE_OPTIONS = [
  { value: 1, label: 'Mensal' },
  { value: 2, label: 'Avulso' },
]

const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'Tipo de serviço',
  },
  {
    id: 'default_value',
    numeric: true,
    disablePadding: false,
    label: 'Valor Base',
  },
  {
    id: 'default_value_laundry',
    numeric: true,
    disablePadding: false,
    label: 'Valor Parceiro',
  },
  { id: 'os_type', numeric: false, disablePadding: false, label: 'Tipo na OS' },
  {
    id: 'default_to_laundry',
    numeric: false,
    disablePadding: false,
    label: 'Serviço Padrão',
  },
  {
    id: 'active',
    numeric: false,
    disablePadding: false,
    label: 'Ativo',
  },
]

const useStyles = makeStyles({
  table: { minWidth: 750 },
  tableStickHeader: { maxHeight: 'calc(100vh - 290px)' },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
})

const ServiceTypesTable = ({ onlyActiveItems = false, editingId }) => {
  const styles = filterStylesComponents()
  const dispatch = useDispatch()
  const items = useSelector(state => state.laundries.laundryServiceTypes)
  const serviceTypes = useSelector(state => state.laundries.serviceTypes)

  const classes = useStyles()

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [itemToDelete, setItemToDelete] = useState(null)

  const [openDefaultModal, setOpenDefaultModal] = useState(false)
  const [itemToToggleDefault, setItemToToggleDefault] = useState(null)

  const [openDeactivateAllModal, setOpenDeactivateAllModal] = useState(false)

  const [formmatedItens, setFormmatedItems] = useState([])

  const [order, setOrder] = useState('desc')
  const [orderBy, setOrderBy] = useState('id')

  const [selectedAll, setSelectedAll] = useState(false)

  const selectedItems = formmatedItens.filter(item => item.selected)
  const allSelectedActive =
    selectedItems.length > 0 && selectedItems.every(item => !!item.id)

  const onRequestSort = useCallback(
    (event, property) => {
      const isDesc = orderBy === property && order === 'desc'
      setOrder(isDesc ? 'asc' : 'desc')
      setOrderBy(property)
    },
    [order, orderBy]
  )

  const handleOpenDeleteModal = (id = null) => {
    setItemToDelete(id)
    setOpenDeleteModal(true)
  }

  const handleConfirmDelete = () => {
    if (!itemToDelete) return
    dispatch(removeLaundryServiceType(itemToDelete, editingId))
    setOpenDeleteModal(false)
    setItemToDelete(null)
  }

  const handleOpenDefaultModal = (id, isDefault) => {
    setItemToToggleDefault({ id, isDefault })
    setOpenDefaultModal(true)
  }

  const handleConfirmToggleDefault = () => {
    if (!itemToToggleDefault) return
    const { id, isDefault } = itemToToggleDefault
    dispatch(
      updateLaundryServiceType(
        id,
        { default_to_laundry: isDefault ? 0 : 1 },
        editingId
      )
    )
    setOpenDefaultModal(false)
    setItemToToggleDefault(null)
  }

  const initItems = () => {
    const formmatedItens = items?.map(item => ({
      id: item?.id,
      service_type_id: item?.service_type?.id,
      service_type_name: item?.service_type?.name,
      default_value: item?.service_type?.default_value,
      value: item?.value,
      default_to_laundry: item?.default_to_laundry,
      active: 1,
      os_type: item?.os_type,
      selected: false,
    }))

    if (onlyActiveItems) return setFormmatedItems([...formmatedItens])

    const formmatedServiceTypes = serviceTypes?.map(item => ({
      id: null,
      service_type_id: item?.id,
      service_type_name: item?.name,
      default_value: item?.default_value,
      value: parseFloat(item?.default_value),
      default_to_laundry: 0,
      active: 0,
      os_type: 2,
      selected: false,
    }))

    setFormmatedItems([...formmatedItens, ...formmatedServiceTypes])
  }

  const handleSelectAll = () => {
    const current = !selectedAll

    if (!current) {
      setSelectedAll(current)
      return initItems()
    }

    const newItems = formmatedItens?.map(item => ({
      ...item,
      selected: current,
      active: 1,
    }))

    setFormmatedItems(newItems)
    setSelectedAll(current)
  }

  const handleSelectRow = serviceTypeId => {
    const newItems = formmatedItens?.map(item => {
      if (item?.service_type_id != serviceTypeId) return item
      const active = item?.id ? item?.active : !item?.selected

      return {
        ...item,
        selected: !item?.selected,
        active: active,
      }
    })

    setFormmatedItems(newItems)
  }

  const onValueChange = (serviceTypeId, values) => {
    setFormmatedItems(prev =>
      prev.map(item =>
        item.service_type_id == serviceTypeId
          ? { ...item, value: values.floatValue ?? 0 }
          : item
      )
    )
  }

  const onValueBlur = row => {
    if (!row.id) return
    const original = items.find(i => i.id == row.id)
    if (!original || original.value == row.value) return
    dispatch(updateLaundryServiceType(row.id, { value: row.value }, editingId))
  }

  const onOsTypeChange = (serviceTypeId, value) => {
    setFormmatedItems(prev =>
      prev.map(item =>
        item.service_type_id == serviceTypeId
          ? { ...item, os_type: value }
          : item
      )
    )

    const item = formmatedItens.find(i => i.service_type_id == serviceTypeId)
    if (!item?.id) return
    const original = items.find(i => i.id == item.id)
    if (!original || original.os_type == value) return
    dispatch(updateLaundryServiceType(item.id, { os_type: value }, editingId))
  }

  const handleMakeMonthly = () => {
    setFormmatedItems(prev =>
      prev.map(item => (item.selected ? { ...item, os_type: 1 } : item))
    )
  }

  const handleMakeSingle = () => {
    setFormmatedItems(prev =>
      prev.map(item => (item.selected ? { ...item, os_type: 2 } : item))
    )
  }

  const handleToggleAll = () => {
    if (allSelectedActive) {
      setOpenDeactivateAllModal(true)
    } else {
      const inactiveItems = selectedItems
        .filter(item => !item.id)
        .map(item => ({
          service_type_id: item.service_type_id,
          value: item.value,
          os_type: item.os_type,
        }))
      if (!inactiveItems.length) return
      dispatch(bulkSaveLaundryServiceTypes({ items: inactiveItems }, editingId))
    }
  }

  const handleConfirmDeactivateAll = () => {
    const ids = selectedItems.filter(item => !!item.id).map(item => item.id)
    dispatch(bulkDestroyLaundryServiceTypes(ids, editingId))
    setOpenDeactivateAllModal(false)
  }

  const handleActivateItem = row => {
    dispatch(
      bulkSaveLaundryServiceTypes(
        {
          items: [
            {
              service_type_id: row.service_type_id,
              value: row.value,
              os_type: row.os_type,
            },
          ],
        },
        editingId
      )
    )
  }

  const handleSave = () => {
    const selectedItems = formmatedItens
      .filter(item => item.selected)
      .map(item => ({
        service_type_id: item.service_type_id,
        value: item.value,
        os_type: item.os_type,
      }))

    if (!selectedItems.length) return

    dispatch(bulkSaveLaundryServiceTypes({ items: selectedItems }, editingId))
    setSelectedAll(false)
  }

  useEffect(() => {
    initItems()
  }, [items, serviceTypes, onlyActiveItems])

  const hasSelected = formmatedItens.some(item => item.selected)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TableContainer
          style={{
            maxHeight: 'calc(100vh - 322px)',
          }}
        >
          <Table className={classes.table} size="medium" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCellHeader style={{ width: '40px' }}>
                  <CustomCheckbox
                    checked={selectedAll}
                    onChange={handleSelectAll}
                  />
                </StyledTableCellHeader>

                <TableHeadCells
                  headCells={headCells}
                  onRequestSort={onRequestSort}
                  order={order}
                  orderBy={orderBy}
                />
              </TableRow>
            </TableHead>
            <TableBody>
              {stableSort(formmatedItens, getSorting(order, orderBy)).map(
                (row, i) => {
                  const isDefault = row.default_to_laundry == 1
                  const active = !!row?.id

                  return (
                    <TableRow hover tabIndex={-1} key={row.service_type_id}>
                      <StyledTableCellHeader style={{ padding: '12px' }}>
                        <CustomCheckbox
                          checked={row?.selected}
                          onChange={() => handleSelectRow(row?.service_type_id)}
                        />
                      </StyledTableCellHeader>
                      <StyledTableCellBody>
                        {row?.service_type_name}
                      </StyledTableCellBody>
                      <StyledTableCellBody>
                        {exportFormatedMoney(row?.default_value)}
                      </StyledTableCellBody>
                      <StyledTableCellBody>
                        <Tooltip
                          title={
                            !active && !row?.selected
                              ? 'Selecione o item para editar o valor'
                              : !active
                              ? 'Valor será salvo ao clicar em Salvar'
                              : 'O valor será salvo ao sair do campo'
                          }
                        >
                          <span>
                            <NumberFormat
                              name="value"
                              value={row.value}
                              onValueChange={values =>
                                onValueChange(row.service_type_id, values)
                              }
                              onBlur={() => onValueBlur(row)}
                              customInput={InputBase}
                              decimalScale={2}
                              decimalSeparator=","
                              thousandSeparator="."
                              displayType="input"
                              fixedDecimalScale
                              startAdornment="R$"
                              style={{
                                width: '90px',
                                marginRight: '4px',
                                borderBottom: `2px solid ${colors.graylight}`,
                                color: colors.gray,
                                fontSize: '14px',
                              }}
                              disabled={!active && !row?.selected}
                              readOnly={!active && !row?.selected}
                              inputProps={{
                                style: {
                                  fontSize: '14px',
                                  textAlign: 'center',
                                },
                              }}
                            />
                          </span>
                        </Tooltip>
                      </StyledTableCellBody>
                      <StyledTableCellBody style={{ textAlign: 'left' }}>
                        {row?.active == 1 && (
                          <Select
                            value={row.os_type || 1}
                            onChange={e =>
                              onOsTypeChange(
                                row.service_type_id,
                                e.target.value
                              )
                            }
                            disableUnderline
                            style={{ fontSize: '14px' }}
                          >
                            {OS_TYPE_OPTIONS.map(opt => (
                              <MenuItem key={opt.value} value={opt.value}>
                                {opt.label}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      </StyledTableCellBody>
                      <StyledTableCellBody style={{ textAlign: 'left' }}>
                        {row?.os_type == 1 && active && (
                          <CustomSwitch
                            checked={isDefault}
                            onChange={() =>
                              handleOpenDefaultModal(row?.id, isDefault)
                            }
                          />
                        )}
                      </StyledTableCellBody>
                      <StyledTableCellBody>
                        <CustomSwitch
                          checked={active}
                          onChange={() =>
                            active
                              ? handleOpenDeleteModal(row?.id)
                              : handleActivateItem(row)
                          }
                        />
                      </StyledTableCellBody>
                    </TableRow>
                  )
                }
              )}
            </TableBody>
          </Table>

          <BasePopUp
            open={openDeleteModal}
            type="error"
            title="Excluir Tipo de Serviço"
            message="Deseja realmente excluir este tipo de serviço da lavanderia?"
            handleOpen={() => setOpenDeleteModal(false)}
            onConfirm={handleConfirmDelete}
          />

          <BasePopUp
            open={openDefaultModal}
            type="info"
            title="Alterar Serviço Padrão"
            message={
              itemToToggleDefault?.isDefault
                ? 'Deseja realmente remover este serviço como padrão da lavanderia?'
                : 'Deseja realmente tornar este serviço como padrão da lavanderia?'
            }
            handleOpen={() => setOpenDefaultModal(false)}
            onConfirm={handleConfirmToggleDefault}
          />

          <BasePopUp
            open={openDeactivateAllModal}
            type="error"
            title="Desativar Todos os Serviços"
            message="Deseja realmente desativar todos os tipos de serviço desta lavanderia?"
            handleOpen={() => setOpenDeactivateAllModal(false)}
            onConfirm={handleConfirmDeactivateAll}
          />
        </TableContainer>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Typography variant="caption" style={{ color: colors.grayMedium }}>
              Selecione itens na tabela para habilitar as ações abaixo
            </Typography>
          </Grid>
          <Grid item>
            <Button onClick={handleSelectAll} className={styles.btnAdd}>
              Selecionar Todos
            </Button>
          </Grid>
          <Grid item>
            <Button
              disabled={!hasSelected}
              onClick={handleMakeMonthly}
              className={styles.btnAdd}
            >
              Tornar Mensal
            </Button>
          </Grid>
          <Grid item>
            <Button
              disabled={!hasSelected}
              onClick={handleMakeSingle}
              className={styles.btnAdd}
            >
              Tornar Avulso
            </Button>
          </Grid>
          <Grid item>
            <Button
              disabled={!hasSelected}
              onClick={handleToggleAll}
              className={styles.btnAdd}
            >
              {allSelectedActive ? 'Desativar Todos' : 'Ativar Todos'}
            </Button>
          </Grid>
          <Grid item>
            <Button
              disabled={!hasSelected}
              onClick={handleSave}
              className={styles.btnAdd}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ServiceTypesTable
